import type { CommboxArticleBlockFragment_ArticleParagraph_Fragment } from '../graphql/article-block.fragment.gql-types';

export const MOCKED_ARTICLE_PARAGRAPH1: CommboxArticleBlockFragment_ArticleParagraph_Fragment =
  {
    __typename: 'ArticleParagraph',
    text: '@Dummy Lorem ipsum dolor sit  amet@Dummy 2, https://reactjs.org/ consectetur adipiscing elit. Quisque sit amet pellentesque lorem. Duis et elit eget arcu rutrum vestibulum. Morbi vitae erat sit amet est pellentesque scelerisque eu ac elit. Sed at nunc ac ex ultrices vestibulum. Sed eu sodales sapien, id vestibulum lorem. Aliquam pulvinar ante dui, finibus rhoncus ante ultrices pharetra. Mauris sollicitudin dapibus interdum. Proin vitae neque rutrum augue vulputate luctus. Integer nec molestie felis. Pellentesque consectetur fringilla arcu ac semper. Curabitur sed odio in ante auctor semper sed quis orci. Duis purus quam, vulputate ac porttitor sit amet, interdum nec massa. Nam porttitor dui eu orci egestas dapibus. Praesent tempus suscipit dui sed rutrum.',
    markups: [
      {
        __typename: 'ArticleMentionMarkup',
        userId: '15728351.e29ae5',
        end: 6,
        start: 0,
        user: { pageName: 'Dummy_DummyDummy' },
      },
      {
        __typename: 'ArticleMentionMarkup',
        userId: '15728351.e29ae5',
        end: 42,
        start: 34,
        user: { pageName: 'Dummy_DummyDummy2' },
      },
    ],
  };

export const MOCKED_ARTICLE_PARAGRAPH2: CommboxArticleBlockFragment_ArticleParagraph_Fragment =
  {
    __typename: 'ArticleParagraph',
    text: 'Duis erat nisi, viverra a iaculis quis, auctor ac magna. Aenean eget sem ut massa venenatis egestas eget non nunc. Proin at erat eu enim porta condimentum. Donec blandit dui eget lorem vestibulum euismod. Duis elit magna, aliquam eget augue quis, laoreet cursus ipsum. Integer dapibus mollis enim, eu egestas risus pellentesque et. Nam tincidunt erat non odio vestibulum aliquam. Aenean auctor, nisi sit amet ullamcorper eleifend, nibh lectus porttitor ligula, luctus auctor ante metus ac odio.',
    markups: [],
  };

export const MOCKED_ARTICLE_PARAGRAPH3: CommboxArticleBlockFragment_ArticleParagraph_Fragment =
  {
    __typename: 'ArticleParagraph',
    text: 'Aenean @David Holm ut scelerisque mi, sit amet luctus ligula. Maecenas rutrum tincidunt ligula, sed tincidunt ligula sodales et. Phasellus sit amet massa nec mauris accumsan venenatis ac vel nulla. In hac habitasse platea dictumst. Cras feugiat condimentum bibendum. Curabitur consequat gravida lacus, a tempor purus faucibus nec. Pellentesque euismod viverra pulvinar. Pellentesque gravida, magna vitae tempor commodo, lorem justo suscipit magna, a lobortis tellus ex vulputate sapien.',
    markups: [
      {
        __typename: 'ArticleMentionMarkup',
        userId: '15728351.e29ae5',
        end: 18,
        start: 7,
        user: { pageName: 'David_Holm' },
      },
    ],
  };

export const POSTING_EXAMPLES = [
  {
    __typename: 'EntityPageContentFeedPostingPost',
    attachments: [
      {
        __typename: 'PostingsVideoAttachment',
        globalId: 'surn:x-xing:videos:video:55.8329df',
        id: '55.8329df',
        video: {
          __typename: 'Video',
          id: '55.8329df',
          ownerGlobalId: 'surn:x-xing:postings:video_posting:27.7981a3',
          sprites: [
            {
              __typename: 'VideoImage',
              height: 45,
              source:
                'https://development.video.xing.com/a32b969a-0f10-4256-9891-ffaf11e4871c-44/sprite_single.vtt',
              width: 80,
            },
            {
              __typename: 'VideoImage',
              height: 90,
              source:
                'https://development.video.xing.com/a32b969a-0f10-4256-9891-ffaf11e4871c-44/sprite_double.vtt',
              width: 160,
            },
          ],
          status: 'AVAILABLE',
          title: 'Corona (1).mp4',
        },
      },
    ],
    comment: 'This video is super funny',
    commentArticleV1: [
      {
        __typename: 'ArticleParagraph',
        text: 'This video is super funny',
        markups: [],
      },
    ],
    createdAt: '2020-09-29T10:00:29Z',
    globalId: 'urn:x-xing:entitypages:page:1',
    id: '27.7981a3',
    publicationState: 'PUBLISHED',
  },
  {
    __typename: 'EntityPageContentFeedPostingPost',
    attachments: [
      {
        __typename: 'PostingsPollAttachment',
        votes: 38,
        question: 'How would you rate the Poll Component?',
        options: [
          { text: 'Very Good' },
          { text: 'Very Very Good' },
          { text: 'Very Very Very Good 🤪' },
        ],
        secondsLeft: 380800,
        isClosed: false,
        uuid: '7f15c29d-8804-4a17-a1c7-35d69becbbde',
      },
    ],
    comment: 'This poll is awesome!',
    commentArticleV1: [
      {
        __typename: 'ArticleParagraph',
        text: 'This poll is awesome!',
        markups: [],
      },
    ],
    createdAt: '2020-09-29T10:00:29Z',
    globalId: 'urn:x-xing:entitypages:page:1',
    id: '27.7981a3',
    publicationState: 'PUBLISHED',
  },
  {
    __typename: 'EntityPageContentFeedPostingPost',
    attachments: [
      {
        __typename: 'PostingsLinkAttachment',
        globalId: 'surn:x-xing:social:external_link:8.1fb990',
        link: {
          __typename: 'SocialExternalLinkResult',
          cachedImageUrl: 'https://www.fillmurray.com/680/350',
          description: null,
          sourceDomain: 'www.google.com',
          title: 'Google',
          url: 'https://www.google.com',
        },
      },
    ],
    comment:
      'Lorem ipsum dolor sit amet, aconsetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum',
    createdAt: '2020-07-20T08:20:01Z',
    globalId: 'urn:x-xing:entitypages:page:1',
    id: '29.2c5be1',
    publicationState: 'PUBLISHED',
  },
  {
    __typename: 'EntityPageContentFeedPostingPost',
    attachments: [
      {
        __typename: 'PostingsImageAttachment',
        images: [
          {
            __typename: 'ScaledImage',
            reference: 'large',
            url: 'https://www.fillmurray.com/680/350',
          },
        ],
        uuid: '7f15c29d-8804-4a17-a1c7-35d69becbbde',
      },
      {
        __typename: 'PostingsImageAttachment',
        images: [
          {
            __typename: 'ScaledImage',
            reference: 'large',
            url: 'https://www.fillmurray.com/680/350',
          },
        ],
        uuid: '7f15c29d-8804-4a17-a1c7-35d69becbbdf',
      },
    ],
    comment:
      'Nam liber temporNam liber tempor cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Lorem ipsum dolor sit am cum soluta nobis eleifend option congue nihil imperdiet doming id quod mazim placerat facer possim assum. Lorem ipsum dolor sit am',
    createdAt: '2020-07-20T08:20:01Z',
    globalId: 'urn:x-xing:entitypages:page:10',
    id: '30.2c5be1',
    publicationState: 'PUBLISHED',
    publishAt: '2022-04-30T07:00:00.000Z',
  },
  {
    __typename: 'EntityPageContentFeedPostingPost',
    attachments: [
      {
        __typename: 'PostingsImageAttachment',
        images: [
          {
            __typename: 'ScaledImage',
            reference: 'large',
            url: 'https://www.fillmurray.com/680/350',
          },
        ],
        uuid: '7f15c29d-8804-4a17-a1c7-35d69becbbde',
      },
    ],
    comment: `${MOCKED_ARTICLE_PARAGRAPH1.text}${MOCKED_ARTICLE_PARAGRAPH2.text}${MOCKED_ARTICLE_PARAGRAPH3.text}`,
    commentArticleV1: [
      MOCKED_ARTICLE_PARAGRAPH1,
      MOCKED_ARTICLE_PARAGRAPH2,
      MOCKED_ARTICLE_PARAGRAPH3,
    ],
    createdAt: '2020-07-20T08:20:01Z',
    globalId: 'urn:x-xing:entitypages:page:10',
    id: '30.2c5be2',
    publicationState: 'PUBLISHED',
    publishAt: '2022-05-30T07:00:00.000Z',
  },
];

export const MOCKED_ACTORS = [
  {
    actorName: 'mytaxi (Intelligent Apps GmbH)',
    globalId: 'urn:x-xing:entitypages:page:1',
    logo: 'https://www.fillmurray.com/g/350/350',
    type: 'PAGE',
  },
  {
    actorName: 'New Work SE',
    globalId: 'urn:x-xing:entitypages:page:10',
    logo: 'https://www.placecage.com/gif/250/250',
    type: 'PAGE',
  },
];
